export const PROD_CONTRACT_ADDRESS_256 = '0x103992432927f7ed1a5b3dc0e34186f80b16d93c';
export const TEST_CONTRACT_ADDRESS_256 = '0x32a45c406a0c7ae83e335d2a55ac97b0f66a30e9';

export const PROD_CONTRACT_ADDRESS_64 = '0xca9b7047a30b48942f61a729ecb1905e4b2a98dc';
export const TEST_CONTRACT_ADDRESS_64 = '0x2292fed51e5f8c919d200ecf06baf7e230d9d911';

export const CONTRACT_ADDRESS_256 = process.env.NODE_ENV === 'production'
    ? PROD_CONTRACT_ADDRESS_256
    : TEST_CONTRACT_ADDRESS_256;

export const CONTRACT_ADDRESS_64 = process.env.NODE_ENV === 'production'
    ? PROD_CONTRACT_ADDRESS_64
    : TEST_CONTRACT_ADDRESS_64;

export const BLOCK_NUMBER = process.env.NODE_ENV === 'production'
    ? 4511043
    : 1216671;

export const METAMASK_URL = 'https://metamask.io/';

export const SIDE_LENGTH_16 = 16;
export const SIDE_LENGTH_8 = 8;

export const GAME_IDS = [
  String(SIDE_LENGTH_16),
  String(SIDE_LENGTH_8),
];

export const MAX_TILES_256 = SIDE_LENGTH_16 * SIDE_LENGTH_16;
export const MAX_TILES_64 = SIDE_LENGTH_8 * SIDE_LENGTH_8;

export const ZERO_X = '0x0000000000000000000000000000000000000000';

export const MAIN_NET = 'https://mainnet.infura.io/Os7yGlrQzShNu9plGJ5Z';
export const TEST_NET = 'https://rinkeby.infura.io/Os7yGlrQzShNu9plGJ5Z';
export const CURR_NET = process.env.NODE_ENV === 'production' ? MAIN_NET : TEST_NET;

export const ETHERSCAN_BASE = process.env.NODE_ENV === 'production'
  ? 'etherscan.io'
  : 'rinkeby.etherscan.io';

export const HASH_HEROES_URL = 'https://hashheroes.com';
export const FACEBOOK_URL = `https://www.facebook.com/sharer/sharer.php?u=${HASH_HEROES_URL}`
export const TWITTER_URL = `https://twitter.com/intent/tweet?text=Check out Hash Heroes! A daring game played on the Ethereum blockchain.&hashtags=hashheroes&url=${HASH_HEROES_URL}`;

export const WELCOME_NOTIFICATION_DELAY = 1000; // one second



// WEBPACK FOOTER //
// ./src/constants.js